import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

const DEFAULT_IS_DARK = false;

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme-dark-mode');
    return saved !== null ? saved === 'true' : DEFAULT_IS_DARK;
  });

  const toggleDarkMode = (dark) => {
    setIsDarkMode(dark);
    localStorage.setItem('theme-dark-mode', String(dark));
  };

  // 页面背景色：浅色为原始白灰色 #f0f2f5，深色为 #141414
  const getBackgroundColor = () => {
    return isDarkMode ? '#141414' : '#f0f2f5';
  };

  // 内容区背景
  const getContentBg = () => {
    return isDarkMode ? '#1f1f1f' : '#ffffff';
  };

  // 主文字颜色
  const getTextColor = () => {
    return isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)';
  };

  // 次要文字颜色
  const getTextColorSecondary = () => {
    return isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)';
  };

  // 边框颜色
  const getBorderColor = () => {
    return isDarkMode ? '#434343' : '#d9d9d9';
  };

  return (
    <ThemeContext.Provider value={{ 
      isDarkMode,
      toggleDarkMode,
      getBackgroundColor,
      getContentBg,
      getTextColor,
      getTextColorSecondary,
      getBorderColor
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);